export enum WeekdayOrdinalEnum {
  ALL = 0,
  FIRST = 1,
  SECOND = 2,
  THIRD = 3,
  FOURTH = 4,
  FIFTH = 5,
  LAST = 99,
}
